export default __webpack_public_path__ + "static/logo_groupe-0e2d67368050023cf18e83d192e2a4b7.png";